import axios from 'axios';

export default class LoginApi {
  constructor(baseUrl, config) {
    this.baseUrl = baseUrl;
    this.config = config;
  }

  postLogin(values) {
    const { districtId, username, password } = values;

    let query = {
      username,
      password,
      districtId,
    };

    const url = `${this.baseUrl}/api/account/login`;
    return axios.post(url, query, this.config);
  }

  postRegister(values) {
    const {
      districtId,
      fiscalYear,
      licenseFile,
      username,
      newUsername,
      oldPassword,
      newPassword,
      confirmPassword,
      email,
    } = values;

    let formData = {
      username,
      fiscalYear,
      licenseFile,
      newUsername,
      newPassword,
      districtId,
      oldPassword,
      password: newPassword,
      confirmPassword,
      email,
    };

    const url = `${this.baseUrl}/api/account/register`;
    return axios.post(url, formData, this.config);
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/api/LoginApi.js